module.exports = __webpack_public_path__ + "img/serve5.8475b279.png";